module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "styling1.0e2d31b3.jpg" + "?" + Date.now();